import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import { useTheme } from "styled-components";
import { CenterPanelContext } from "../..";
import { API_CALLS } from "../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../redux";
import { Loader } from "../../../../../Common";
import {
  FlexColumn,
  FlexRow,
  FlexRowCenter,
} from "../../../../../Common/Styles";
import NewsFeedFilterProps from "../NewsFeedFilter";
import { ConfirmationContainer, Container, WarningCircle } from "./style";

const RemoveCircle = ({
  setStepKey,
  stepKey,
}: NewsFeedFilterProps.RemoveCircleProps) => {
  const { typography, Color } = useTheme();
  const { setSelectedCircle } = useContext(CenterPanelContext);
  const { listOfCircles, deleteCircle_API_STATUS } = useAppSelector(
    (state) => state.circle
  );
  const removeCircle = listOfCircles.find((circle) => circle.id === stepKey);
  return (
    <FlexColumn $gapInPx={8} style={{ position: "relative" }}>
      <FlexRow>
        <FlexRowCenter $gapInPx={8}>
          <Components.IconButton
            disabled={false}
            iconType="ArrowLeft"
            kind="Tertiary"
            size="XXS"
            onClick={() => setStepKey("")}
          />
          <Components.Text
            style={{ tokenStyle: typography.Body.S }}
            text="Remove circle"
            fontWeight="font-weight-semibold"
            lineHeight="line-height-75"
          />
        </FlexRowCenter>
      </FlexRow>
      <Components.ListItem type="Divider" />
      <Container>
        <Components.Text
          style={{ tokenStyle: typography.Body.S }}
          text="Circles"
          color={Color.text["text-emphasize-brand-bolder"].value}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-75"
        />
        <ConfirmationContainer>
          <WarningCircle>
            <Components.Icon
              type="AlertTriangle"
              color={"#DC6803"}
              size="16px"
            />
          </WarningCircle>
          <FlexColumn>
            <Components.Text
              style={{ tokenStyle: typography.Body.M }}
              text="Are you sure you want to remove this circle?"
              lineHeight="line-height-100"
            />
            <Components.Chip
              content={removeCircle?.name ?? ""}
              kind="Neutral"
              leftNode={
                <Components.Icon
                  type="Circle"
                  color={removeCircle?.colour ?? ""}
                  size="16px"
                />
              }
            />
          </FlexColumn>
        </ConfirmationContainer>
      </Container>
      <FlexRow $gapInPx={8}>
        <Components.Button
          color="Neutral"
          kind="Primary"
          disabled={false}
          label="Cancel"
          onClick={() => setStepKey("")}
          size="Small"
          iconType="ArrowLeft"
          iconPosition="left"
          width="fill"
        />
        <Components.Button
          color="Negative"
          kind="Secondary"
          disabled={false}
          label="Remove"
          onClick={() => {
            API_CALLS.CIRCLE.deleteCircle({ id: stepKey }).then(() => {
              setSelectedCircle((prev) =>
                prev.filter((circle) => circle.id !== stepKey)
              );
              setStepKey("");
            });
          }}
          size="Small"
          iconType="Trash2"
          iconPosition="left"
          width="fill"
        />
      </FlexRow>
      {deleteCircle_API_STATUS === "progress" && <Loader />}
    </FlexColumn>
  );
};

export default RemoveCircle;
